
import InputField from "../../ReusableComponents/InputField";
import SelectField from "../../ReusableComponents/SelectField";
import { AEROMEGH_SERVICES, PRICE_BY_TYPES, STATUS } from "../../appConstants";
import { Button } from "../../Components/Helper";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import Form from "../../ReusableComponents/Form";
import Popup from "../../ReusableFunctions/Popup";
import SelectLocation from "../../features/MyLocations/SubComponents/SelectLocation";
import CustomToggle from "../../ReusableComponents/CustomToggle";
import Modal from "../../ReusableComponents/Modal";
import { modelNameValidation, nameValidation, phoneNumValidation, selectFieldValidation } from "../../utils/inputValidations";
import { setHours, setMinutes, isSameDay } from "date-fns"; // Assuming you're using date-fns for date utilities
import { acresToSquareKilometers } from "../../ReusableFunctions/reusableFunctions";
import CreatableSelectField from "../../ReusableComponents/CreatableSelectField";
import { v4 as uuid } from 'uuid'
import Calender from "../../assets/blueCalendar.svg"
import Clock from "../../assets/blueClock.svg"
import Loading from "../../ReusableFunctions/Loader";
import { getAllDSPs } from "../../apis/adminAPIs/dsp";
import { getDspLocations } from "../../apis/BhuMeetTeams/CustomerSuccessEngineer/locations";
import { getSprayingRequestParameters, placeRequestFromCES } from "../../apis/BhuMeetTeams/CustomerSuccessEngineer/request";
import { getApplicableCoupons } from "../../apis/BhuMeetTeams/CustomerSuccessEngineer/coupons";
import { COUPON_TYPES } from "../../appConstants";
import { createUserIfNotExists, getUserFromMobileNumber } from "../../apis/users";
import { getStates } from "../../apis/locations";
const CreateRequest = ({ onClose,user,onuserCreate }) => {
    function setNext15MinuteInterval() {
        const date = new Date(); // Get the current date and time

        const minutes = date.getMinutes(); // Get the current minutes
        const nextInterval = Math.ceil(minutes / 15) * 15; // Calculate the next 15-min interval

        // If the next interval is 60, move to the next hour
        if (nextInterval === 60) {
            date.setHours(date.getHours() + 1); // Increment the hour
            date.setMinutes(0); // Set minutes to 0 (start of next hour)
        } else {
            date.setMinutes(nextInterval); // Set the minutes to the next interval
        }

        date.setSeconds(0); // Reset seconds to 0
        date.setMilliseconds(0); // Reset milliseconds to 0

        return date;
    }
    // Set the time to 11:00 AM
    const [request, setRequest] = useState({
        mobile_number: user?.mobile_number || "",
        time: new Date(setNext15MinuteInterval()),
        field_lat: "",
        field_lng: "",
        field_name: { label: "", value: "" },
        field_address: "",
        field_area: null,
        applied_coupons: {label:"",value:""},
        price_by: false,
        dsp: { label: "", value: "" },
        crop: { label: "", value: "" },
        crop_stage: { label: "", value: "" },
        pesticides: { label: "", value: "" },
        location_id: { label: "", value: "" },
        service_amount: null,
        cgst: null,
        sgst: null,
        pesticide_per_acre_subsidy:0,
        pesticides_subsidy:0,
        total_applied_coupons:[],
        crop_price_per_acre:0,
        total_amount: 0,
        service_amount_with_subsidy:0,
        name: user?.name ||"",
        state:user?.state?{label:user?.state,value:user?.state}: {label:"",value:""}
    })
    const [crops, setCrops] = useState([])
    const [cropStages, setCropStages] = useState([])
    const [locations, setLocations] = useState([])
    const [dsps, setDsps] = useState([])
    const [pesticides, setPesticides] = useState([])
    const [applicableCoupons, setApplicableCoupons] = useState([])
    const [couponLoading, setCouponLoading] = useState(false)
    const [mapLocation, setMapLocation] = useState()
    const [disableName, setDisableName] = useState(false)
    const [showDatePicker, setShowDatePicker] = useState(false)
    const [showTimePicker, setShowTimePicker] = useState(false)
    const [loading, setLoading] = useState(true)
    const [disableIfUserNotExists, setDisableIfUserNotExists] = useState(false);
    const [isFetchingUser, setIsFetchingUser] = useState(false)
    const [showCreateUser, setshowCreateUser] = useState(false);
    const [disableState, setdisableState] = useState(false);
    const [userDetails, setUserDetails] = useState(user || undefined);
    const [states, setStates] = useState([])
    const [statesLoading, setStatesLoading] = useState(false);
   const [parametersLoading, setparametersLoading] = useState(false);
    const handleAddNewAgroChemical = (newOption) => {
        if (newOption) {
            const newAgro = {
                id: uuid(),
                chemical_name: newOption,
                subsidy: null
            }
            setPesticides(prev => ([...prev, newAgro]))
            setRequest(prev => ({ ...prev, pesticides: { label: newAgro.chemical_name, value: newAgro.id } }))
        }
    }

    const getStatesFunc = async () => {
      try {
        setStatesLoading(true)
        const states = await getStates()
        setStates(states?.records)
        setStatesLoading(false)
      } catch (err) {
        setStatesLoading(false)
        console.log(err);
        Popup.alert("Error", err.errorMessage, "ERROR");
      }
    }
    const initData = async () => {
        try {
            const{dsps}=await getAllDSPs();
            await getStatesFunc();
            setDsps(dsps.filter(d=>d.dsp_is_active));
            setLoading(false)
        } catch (e) {
            setLoading(false)
            console.log(e)
            Popup.alert("Something went wrong", e?.message, "ERROR")
        }
    }

    const getUserFromMobileNumberFunc = async (mobileNo) => {
      try {
          setIsFetchingUser(true)
          setRequest((prevRequest)=>({
            ...prevRequest,
            name:"",
            state:{label:"",value:""}
          }))
          const {user} = await getUserFromMobileNumber(mobileNo)
          if (user) {
              setDisableIfUserNotExists(false);
              setDisableName(true);
              setdisableState(true);
              console.log("user",user);
              setRequest(prev => ({ ...prev, name: user.user_name, mobile_number: mobileNo,state:{label:user?.state,value:user?.state} }))
              let updatedUser={...user,id:user?.user_id,mobile_number:user?.user_mobile};
              setUserDetails(updatedUser)
          } else {
              setDisableName(false)
              setdisableState(false);
              setshowCreateUser(true);
              setDisableIfUserNotExists(true);
          }
          setIsFetchingUser(false)
      } catch (e) {
          setIsFetchingUser(false)
          setDisableName(false)
          console.log(e)
      }
  }

    const handleCreateRequest = async (updatedReq) => {
        Loading.set(true)
        setLoading(true);
        try {
            let finalReq = { ...request }
            finalReq.price_by = updatedReq.price_by == true ? PRICE_BY_TYPES.TANK : PRICE_BY_TYPES.ACRE
            finalReq.field_area = updatedReq.field_area;
            finalReq.crop_name = crops.find(c => c.crop_id == updatedReq?.crop?.value)?.crop_name || "";
            finalReq.crop_stage = cropStages.find(c => c == updatedReq?.crop_stage?.value)
            //add field addres, name ,lat lng etc
            finalReq.location_id = updatedReq?.location_id?.value;
            finalReq.time = new Date(updatedReq.time).toISOString() //check this
            //calculate service and total amount
            finalReq.cgst = updatedReq.cgst;
            finalReq.sgst = updatedReq.sgst;



            // CALCULATIONS
            const field_area = Number(finalReq.field_area)
            console.log('field_area',field_area)
            const crops_price = Number((crops.find(c => c.crop_id == finalReq?.crop?.value)?.cost) || 0)
            console.log('crops_price',crops_price)
            const service_amount = field_area * crops_price
            console.log('service_amount',service_amount)
            const subsidy_per_acre = Number(pesticides.find(p => p.id == finalReq?.pesticides?.value)?.subsidy || 0)

            let total_subsidy = subsidy_per_acre * field_area
            console.log('total_subsidy',total_subsidy)
            const service_amount_with_subsidy = service_amount - total_subsidy
            let service_amount_with_cgst_sgst = service_amount_with_subsidy;
            let cgst_amount = 0;
            console.log('service_amount_with_cgst_sgst',service_amount_with_cgst_sgst)
            if (finalReq.cgst && Number(finalReq.cgst)) {
                cgst_amount = (service_amount_with_subsidy * Number(finalReq.cgst) / 100)
            }
            let sgst_amount = 0;
            if (finalReq.sgst && Number(finalReq.sgst)) {
                sgst_amount = (service_amount_with_subsidy * Number(finalReq.sgst) / 100)
            }
            service_amount_with_cgst_sgst = service_amount_with_subsidy + cgst_amount + sgst_amount
            console.log('service_amount_with_cgst_sgst',service_amount_with_cgst_sgst)
            let total_amount = service_amount_with_cgst_sgst
            total_amount = total_amount <= 0 ? 0 : total_amount

            finalReq.pesticides = pesticides.find(p => p.id == updatedReq?.pesticides?.value)?.chemical_name || "";
            finalReq.service_amount = service_amount;
            finalReq.total_amount = total_amount
            finalReq.field_name = mapLocation.name
            finalReq.field_address = mapLocation.address;
            finalReq.field_lat = mapLocation.lat;
            finalReq.field_lng = mapLocation.lng;
            finalReq.request_type = AEROMEGH_SERVICES.SPRAYING
            finalReq.field_area = finalReq.price_by == PRICE_BY_TYPES.ACRE ? acresToSquareKilometers(field_area) : field_area
            finalReq.mobile_number=updatedReq?.mobile_number;
            finalReq.customer_name=updatedReq?.name;
            finalReq.dsp_id=updatedReq.dsp?.value;
            finalReq.applied_coupons=updatedReq.applied_coupons?.value?[updatedReq.applied_coupons?.value]:[]
            setRequest(updatedReq)
            await placeRequestFromCES(finalReq)
            Popup.alert('SUCCESS', 'Request created successfully', 'SUCCESS', onClose)
            Loading.set(false)
            setLoading(false);
        }
        catch (err) {
          setLoading(false);
            Loading.set(false)
            console.log(err)
            Popup.alert("ERROR", err || "Something went wrong while creating request", 'ERROR')
        }
    }

    const getRequestCalculation = async (
        field_area,
        pesticide_per_acre_subsidy,
        crop_price_per_acre,
        appliedCoupons,
      ) => {
        console.log("parameters in the getRequestCalculation", field_area,
            pesticide_per_acre_subsidy,
            crop_price_per_acre,
            appliedCoupons);

        try {
          field_area = Number(field_area)
          const cgst = 0
          const sgst = 0
          const service_amount = crop_price_per_acre * field_area
          const pesticides_subsidy = pesticide_per_acre_subsidy * Number(field_area)
    
          const service_amount_with_subsidy = service_amount - pesticides_subsidy
          if (appliedCoupons.length > 2)
            throw {
              errorMessage: "Bad request, You can only apply 2 coupons.",
              status: 400,
            }
          //////
          let dspCoupons = []
          let bhumeetCoupons = []
    
          bhumeetCoupons = appliedCoupons.filter((ac) => ac.coupon_type === COUPON_TYPES.SYSTEM)
          dspCoupons = appliedCoupons.filter((ac) => ac.coupon_type === COUPON_TYPES.DSP)
          if (bhumeetCoupons.length > 1 || dspCoupons.length > 1)
            throw {
              errorMessage: "Bad request, You can only apply 1 of dsp and 1 of bhumeet coupon.",
              status: 400,
            }
          ///////
          const applied_dsp_coupon_total_amount = getAppliedTotalAmountOfCoupon(service_amount_with_subsidy, dspCoupons[0])
          const applied_bhumeet_coupon_total_amount = getAppliedTotalAmountOfCoupon(
            service_amount_with_subsidy,
            bhumeetCoupons[0],
          )
          const total_discounted_amount_via_coupons = applied_bhumeet_coupon_total_amount + applied_dsp_coupon_total_amount
          const total_dsp_discount_percentage = 0
          const total_discounted_amount_via_dsp = calculatePercentageTotal(
            service_amount_with_subsidy,
            total_dsp_discount_percentage,
          )
          const service_amount_with_applied_discount_and_coupons =
            service_amount_with_subsidy - total_discounted_amount_via_coupons - total_discounted_amount_via_dsp
          const applied_csgt_amount = calculatePercentageTotal(service_amount_with_applied_discount_and_coupons, cgst)
          const applied_sgst_amount = calculatePercentageTotal(service_amount_with_applied_discount_and_coupons, sgst)
          const total_amount_with_applied_coupons_and_gst_and_discounts =
            service_amount_with_applied_discount_and_coupons + applied_csgt_amount + applied_sgst_amount
          const total_amount_without_bhumeet_coupon =
            total_amount_with_applied_coupons_and_gst_and_discounts + applied_bhumeet_coupon_total_amount
          return {
            service_amount,
            pesticides_subsidy,
            service_amount_with_subsidy,
            total_discounted_amount_via_coupons,
            total_discounted_amount_via_dsp,
            service_amount_with_applied_discount_and_coupons,
            applied_csgt_amount,
            applied_sgst_amount,
            total_amount: Number(total_amount_with_applied_coupons_and_gst_and_discounts.toFixed(2)),
            cgst,
            sgst,
            total_amount_without_bhumeet_coupon,
            applied_dsp_coupon_total_amount,
            applied_bhumeet_coupon_total_amount,
            pesticide_per_acre_subsidy,
          }
        } catch (e) {
          throw e
        }
      }

    const requestCalculation = async () => {
        try {
          const {
            service_amount,
            total_amount,
            pesticides_subsidy,
            applied_dsp_coupon_total_amount,
            applied_bhumeet_coupon_total_amount,
            service_amount_with_subsidy
          } = await getRequestCalculation(
            request?.field_area,
            request?.pesticide_per_acre_subsidy,
            request?.crop_price_per_acre,
            request?.total_applied_coupons,
          )
          setRequest((prevRequest) => ({
            ...prevRequest,
            service_amount,
            total_amount,
            pesticides_subsidy,
            applied_dsp_coupon_total_amount,
            applied_bhumeet_coupon_total_amount,
            service_amount_with_subsidy
          }))
        } catch (error) {
          console.error("Error in requestCalculation:", error)
          Popup.alert("Error", "Failed to calculate request amounts", "ERROR")
        }
      }

    const calculatePercentageTotal = (value, percentage) => Number((Number(value) * Number(percentage)) / 100)

    const getAppliedTotalAmountOfCoupon = (service_amount, coupon) => {
        if (coupon) {
          if (coupon.is_discount_in_percentage) {
            const totalAppliedAmountOfCouponViaPercentage = calculatePercentageTotal(
              service_amount,
              coupon.discount_percentage,
            )
            return Number(
              totalAppliedAmountOfCouponViaPercentage < Number(coupon.max_discount_value)
                ? totalAppliedAmountOfCouponViaPercentage
                : coupon.max_discount_value,
            )
          } else {
            return Number(coupon.discount_cost)
          }
        } else return 0
      }

  const getApplicableBhumeetCoupons=async(dsp_id,location_id,user_id)=>{
    try{
        setCouponLoading(true);
        let coupons =await getApplicableCoupons(user_id,location_id,dsp_id);
        let updatedCoupons=request.service_amount_with_subsidy >0? coupons.filter(c => c.coupon_type === COUPON_TYPES.SYSTEM && Number(c.min_order_value) <= Number(request.service_amount_with_subsidy))
        : coupons.filter(c => c.coupon_type === COUPON_TYPES.SYSTEM)
        let couponExists=updatedCoupons.some((c)=>c.id===request?.applied_coupons?.value);
        if(!couponExists){
        setRequest((prevData)=>({
           ...prevData,
           applied_coupons:{
            label:"",
            value:"",
           },
           total_applied_coupons:[]
        }))
        }

        setApplicableCoupons(updatedCoupons)
        setCouponLoading(false);
    }catch(err){
      setCouponLoading(false);
      Popup.alert("Error", err, 'ERROR')
    }
  }


    useEffect(() => {
        initData()
    }, [])

    useEffect(() => {
        if (request?.crop?.label && request.location_id?.value && request.dsp?.value && request?.field_area) {
          requestCalculation()
        } else {
          setRequest((prevRequest) => ({
            ...prevRequest,
            service_amount: 0,
            total_amount: 0,
            applied_dsp_coupon_total_amount: 0,
            applied_bhumeet_coupon_total_amount: 0,
          }))
        }
      }, [
        request.crop?.value,
        request.location_id?.value,
        request.dsp?.value,
        request?.field_area,
        request?.applied_coupons,
        request?.pesticides?.value,
      ])


      useEffect(() => {
        if (request.service_amount_with_subsidy > 0 ) {
            getApplicableBhumeetCoupons(request.dsp.value, request.location_id.value, userDetails?.id);
        }
    }, [request?.service_amount_with_subsidy]);

        useEffect(()=>{
        if(!user){
          setDisableIfUserNotExists(true);
        }else {
          setUserDetails(user);
           setdisableState(true);
          setshowCreateUser(false);
        }
        },[user])
    
    return <Modal
        header={"Create Request"}
        open={true}
        headerContainerStyle={{ padding: "10px 30px" }}
        onClose={onClose}
        closeOnDocumentClick={false}
        contentStyle={{ height: "685px", width: "1200px", boxShadow: " 0px 1px 4px 3px #76767626", border: "1px solid #BFC8D9", borderRadius: "8px", position: "relative" }}
    >
        <div style={{ display: 'flex', width: '100%', height: '100%' }}>
            <div style={{ width: "800px", }}>
                <SelectLocation
                    onLocationChange={(location) => {
                        setMapLocation(location)
                    }}
                />
            </div>
            <Form

                onSubmitForm={(req) => {
                    handleCreateRequest(req)
                }}
                initialValues={request}
                style={{ display: 'flex', flexDirection: 'column', width: "100%", height: 'calc(100% - 65px)', padding: "10px 30px", gap: '20px' }}
            >
                {(onSubmit, formValue) => (
                    <>
                    <div style={{ display: "flex", flexDirection: "column", height: "100%", justifyContent: "space-between", width: "100%", overflow: "auto" }}>
                        <div
                            id="coupen-form"
                            style={{
                                width: "100%",
                                height: "auto",
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gridAutoRows: "auto",
                                gap: "0px 30px",
                                maxHeight: "calc(100% - 200px)",
                            }}
                            >
                                <InputField
                                    label={"Mobile Number"}
                                    placeholder={"Enter Mobile Number "}
                                    name={'mobile_number'}
                                    disabled={user?.mobile_number}
                                    validation={phoneNumValidation}
                                    containerStyle={{ width: '100%' }}
                                    type={'text'}
                                    handleChange={(value) => {
                                        if (value.length === 10) {
                                            getUserFromMobileNumberFunc(value)
                                        } else {
                                            setDisableName(false)
                                        }
                                        setRequest(prev => ({ ...prev, mobile_number: value }))
                                    }}
                                />
                                <InputField
                                    containerStyle={{ width: '100%' }}
                                    label={"Name"}
                                    placeholder={"Enter Customer Name "}
                                    name={'name'}
                                    type={'text'}
                                    disabled={disableName || user?.name}
                                    handleChange={(value) => {
                                        setRequest(prev => ({ ...prev, name: value }))
                                    }}
                                />

                                  <SelectField
                                    isLoading={statesLoading}
                                    isDisabled={disableState}
                                    isSearchable={true}
                                    label={'State'}
                                    placeholderText={"Select state"}
                                    name='state'
                                    styles={{ width: "215px", height: "18px", fontSize: "13px", }}
                                    list={states?.map(state => ({ value: state.state_name_english , label: state.state_name_english }))}
                                    menuPortalTarget={document.getElementById('modalHolder')}
                                    controlStyle={{ height: "auto" }}
                                    handleChange={(selectedstate)=>{
                                      console.log("running")
                                     setRequest((prevRequest)=>({
                                      ...prevRequest,
                                      state:{label:selectedstate?.label,value:selectedstate?.value}
                                     }))
                                    }}
                                    validation={selectFieldValidation}
                                />
                    
                              
                            <SelectField
                                    isLoading={loading}
                                    isDisabled={disableIfUserNotExists}
                                    label={'DSP'}
                                    isSearchable={true}
                                    placeholderText={"selecte DSP"}
                                    name='dsp'
                                    styles={{ width: "215px", height: "18px", fontSize: "13px", }}
                                    list={dsps.map(d=>({label:d.dsp_name,value:d.dsp_id}))}
                                    containerStyle={{
                                        width: "100%",
                                        maxWidth: "100%",
                                        minHeight: "80px",
                                    }}
                                    menuPortalTarget={document.getElementById('modalHolder')}
                                    controlStyle={{ height: "auto" }}
                                    handleChange={async (dsp) => {
                                        setparametersLoading(true)
                                        setRequest(prev => ({ ...prev,
                                             dsp: dsp, 
                                             crop: null,
                                             pesticides:null ,
                                             location_id:null,
                                             applied_coupons:[],
                                             total_applied_coupons:[],
                                             pesticide_per_acre_subsidy:0,
                                             crop_price_per_acre:0,
                                            }))
                                        setCrops([])
                                        setPesticides([])
                                        setApplicableCoupons([])
                                       const locations =await getDspLocations({dspId:dsp?.value,only_active_locations:true});
                                        await getApplicableBhumeetCoupons(dsp?.value,null,userDetails?.id);
                                
                                       setLocations(locations)
                                       setparametersLoading(false);
                                    }}
                                    validation={selectFieldValidation}
                                />

                                <SelectField
                                    isLoading={parametersLoading}
                                    isDisabled={disableIfUserNotExists}
                                    label={'Location'}
                                    isSearchable={true}
                                    placeholderText={"Select Location"}
                                    name='location_id'
                                    styles={{ width: "215px", height: "18px", fontSize: "13px", }}
                                    list={locations?.filter((l)=>l.is_active)?.map(l => ({ label: l.name, value: l.id }))}
                                    containerStyle={{
                                        width: "100%",
                                        maxWidth: "100%",
                                        minHeight: "80px",
                                    }}
                                    menuPortalTarget={document.getElementById('modalHolder')}
                                    controlStyle={{ height: "auto" }}
                                    handleChange={async (location) => {
                                        setparametersLoading(true)
                                        setRequest(prev => ({ 
                                            ...prev,
                                             location_id: location, 
                                             crop: null,
                                             pesticides:null,
                                             applied_coupons:[],
                                             crop_price_per_acre:0,
                                             total_applied_coupons:[],
                                             pesticide_per_acre_subsidy:0,
                                            }))
                                        setApplicableCoupons([])
                                         const parameters= await getSprayingRequestParameters({dspId:request?.dsp?.value,locationId:location?.value})
                                         await getApplicableBhumeetCoupons(request?.dsp?.value,location?.value,userDetails?.id);
                                        const { crop_stages, pesticides,location_crops_cost_list} = parameters
                                        setCrops(location_crops_cost_list);
                                        setCropStages(crop_stages)
                                        setPesticides(pesticides);
                                        setparametersLoading(false)
                                    }}
                                    validation={selectFieldValidation}
                                />
                                 
                                 <div style={{ display: 'flex', width: '100%', gap: '10px', alignItems: 'start' }}>
                                    <div className='input_field' style={{ gap: "5px", width: '100%' }}>
                                        <label htmlFor="expiryDate" style={{ fontSize: '13px', color: '#3B3B3B', }}>{'Date'}</label>
                                        <div
                                            className='input-date'
                                            style={{ position: 'relative', display: 'flex', flexDirection: 'column', rowGap: '5px', justifyContent: 'center', width: "100%", height: "35px", border: '1.4px solid rgba(217, 217, 217, 0.84)', }}
                                            onClick={() => {
                                              if(disableIfUserNotExists) return ;
                                              setShowDatePicker(true)
                                            }}
                                        >
                                            <DatePicker
                                                readOnly
                                                disabled={disableIfUserNotExists}
                                                dateFormat="dd/MM/yyyy" 
                                                minDate={new Date()}
                                                onClickOutside={() => setShowDatePicker(false)}
                                                open={showDatePicker}
                                                value={new Date(request.time)}
                                                selected={new Date(request.time)}
                                                className="input-date-hidden"
                                                containerStyle={{ width: '100%' }}
                                                onChange={(date, e) => {
                                                    e.stopPropagation()
                                                    const selectedDate = new Date(date)
                                                    setRequest(prev => {
                                                        const updatedTime = prev.time ? new Date(prev.time) : new Date();  // Get current time if not selected
                                                        // Merge the selected date with the stored time
                                                        let updatedDateTime = new Date(
                                                            selectedDate.setHours(updatedTime.getHours(), updatedTime.getMinutes())
                                                        );
                                                        return { ...prev, time: new Date(updatedDateTime) }
                                                    })
                                                    setShowDatePicker(false)
                                                }}
                                            />
                                            <img src={Calender} alt='Calender' style={{ width: "18px", position: "absolute", right: "15px" }} />
                                        </div>
                                    </div>
                                </div>

                                <CreatableSelectField
                                    isLoading={parametersLoading}
                                    onCreateOption={handleAddNewAgroChemical}
                                    isSearchable={true}
                                    isDisabled={disableIfUserNotExists}
                                    placeholder={"Select AgroChemical"}
                                    label={'Agrochemical'}
                                    name={'pesticides'}
                                    styles={{ width: "215px", height: "18px", fontSize: "13px", }}
                                    list={pesticides.map(l => ({ label: l.chemical_name, value: l.id }))}
                                    containerStyle={{
                                        width: "100%",
                                        maxWidth: "100%",
                                        minHeight: "80px",
                                    }}
                                    menuPortalTarget={document.getElementById('modalHolder')}
                                    controlStyle={{ height: "auto" }}
                                    handleChange={(pesticide) => {
                                       let pesticide_per_acre_subsidy=pesticides.find(p=>p.id===pesticide?.value)?.subsidy
                                        setRequest(prev => ({ ...prev, pesticides: pesticide,pesticide_per_acre_subsidy }))
                                    }}
                                    validation={modelNameValidation}
                                />
                               

                                <SelectField
                                    isLoading={loading || parametersLoading}
                                    isDisabled={disableIfUserNotExists}
                                    isSearchable={true}
                                    label={'Crop'}
                                    placeholderText={"Select Crop"}
                                    name='crop'
                                    styles={{ width: "215px", height: "18px", fontSize: "13px", }}
                                    list={crops.map(l => ({ label: l.crop_name, value: l.crop_id }))}
                                    containerStyle={{
                                        width: "100%",
                                        maxWidth: "100%",
                                        minHeight: "80px",
                                    }}
                                    menuPortalTarget={document.getElementById('modalHolder')}
                                    controlStyle={{ height: "auto" }}
                                    handleChange={async (crop) => {
                                        let crop_price_per_acre=Number(crops.find((c)=>c?.crop_id===crop?.value)?.cost)
                                        setRequest(prev => ({ ...prev, crop: crop,crop, crop_price_per_acre}))
                                    }}
                                    validation={selectFieldValidation}
                                />

                                <SelectField
                                    isLoading={loading || couponLoading}
                                    isDisabled={disableIfUserNotExists}
                                    isSearchable={true}
                                    label={'BhuMeet Coupons'}
                                    placeholderText={"Select BhuMeet Coupons"}
                                    name='applied_coupons'
                                    styles={{ width: "215px", height: "18px", fontSize: "13px", }}
                                    list={applicableCoupons.map((c)=>({label:c.coupon_code,value:c.id}))}
                                    containerStyle={{
                                        width: "100%",
                                        maxWidth: "100%",
                                        minHeight: "80px",
                                    }}
                                    menuPortalTarget={document.getElementById('modalHolder')}
                                    controlStyle={{ height: "auto" }}
                                    handleChange={async (selected_coupon) => {
                                       let total_applied_coupons=[];
                                       total_applied_coupons.push(applicableCoupons.find((c)=>c?.id===selected_coupon?.value));
                                       setRequest(prev => ({ ...prev, applied_coupons:selected_coupon,total_applied_coupons }))
                                    }}
                                />    


                                <div className="relative">
                                  <div style={{ display: 'flex', alignItems: "center", width: '100%',marginTop:"8px",width:"200px"}}>
                                    <CustomToggle
                                     optionsStyles={{padding:"1.5px 15px"}}
                                    containerStyles={{maxWidth:"150px",position:"absolute",right:0}}
                                        onText={"Tank"}
                                        offText={'Acre'}
                                        name={"price_by"}
                                        handleChange={(value) => {
                                            setRequest(prev => ({ ...prev, price_by: value, field_area: null })) //this is required real time to change inputs of acre and tank
                                        }}
                                        defaultValue={request.price_by}
                                    />
                                </div>
                                {request.price_by ?
                                  <InputField
                                        handleChange={value => {
                                            setRequest(prev => ({ ...prev, field_area: value }))
                                        }}
                                        disabled={disableIfUserNotExists}
                                        label={"No. of Tanks"}
                                        placeholder={"Enter no. of tanks"}
                                        name={'field_area'}
                                        validation={{
                                            required: 'Required',
                                            maxLength: {
                                                value: 3,
                                                message: 'Max allowed number is 999.',
                                            },
                                            validate: (value) => {
                                                if (isNaN(value)) {
                                                    return 'Must be a number.';
                                                } else if (value <= 0 || value > 999) {
                                                    return 'No. of tanks should be between 1 to 999';
                                                }
                                            },
                                            format: {
                                                value: /^[0-9]+$/,
                                                message: 'Must be a number.',
                                            },
                                        }}
                                        type={'number'}
                                    />
                                     :
                                    <InputField
                                        handleChange={value => {
                                            setRequest(prev => ({ ...prev, field_area: value }))
                                        }}
                                        disabled={disableIfUserNotExists}
                                        label={"Area (Acre)"}
                                        placeholder={"Enter field area "}
                                        name={'field_area'}
                                        // validation={NoOfUserValidation} //add validation
                                        validation={{
                                            required: 'Required',
                                            validate: (value) => {
                                                if (value == "") {
                                                    return 'Required'
                                                }
                                                else
                                                    if (value.match(/^\d*\.?\d*$/)) {
                                                        const decimalValue = parseFloat(value);
                                                        if (!isNaN(decimalValue) && (decimalValue < 0.1 || decimalValue > 1000.0)) {
                                                            return "Field area in the range of 0.1 to 1000"
                                                        }
                                                    } else if (value < 0) {
                                                        return "Field area in the range of 0.1 to 1000"
                                                    }
                                            }
                                        }}
                                        type={'number'}
                                    />

                                }
                                  </div>     
                                
                     </div>
            
                    <div
                      style={{
                        padding: "0 20px",
                        border: "1px solid #BFC8D9",
                        borderRadius: "7px",
                        visibility: request.service_amount > 0 ? "visible" : "hidden",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "10px 0",
                          fontSize: "15px",
                          fontWeight: "500",
                        }}
                      >
                        Payment Summary
                      </div>
                      <div
                        style={{
                          borderBottom: "1px solid #BFC8D9",
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                          paddingBottom: "5px",
                        }}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <div>
                            <span style={{ fontSize: "13px", color: "#3B3B3B", marginRight: "5px" }}>
                              Service Charges
                            </span>
                            {/* <span style={{ fontSize: "12px", color: "#848484" }}>{`(${paymentSummaryCalculations.field_area} ${(paymentSummaryCalculations?.price_by == PRICE_BY_TYPES.ACRE || !paymentSummaryCalculations?.price_by) ? "Acres" : "Tanks"} x ${(paymentSummaryCalculations.service_amount_per_acre).toFixed(2)} Rs. per ${(paymentSummaryCalculations?.price_by == PRICE_BY_TYPES.ACRE || !paymentSummaryCalculations?.price_by) ? "Acre" : "Tank"})`}</span> */}
                          </div>
                          <div style={{ fontSize: "13px", color: "#3B3B3B" }}>
                            ₹ {request.service_amount ? request.service_amount.toFixed(2) : "00"}
                          </div>
                        </div>
                        {Number(request.pesticides_subsidy) != 0 && (
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div style={{ fontSize: "13px", color: "#3B3B3B" }}>Subsidy</div>
                            <div style={{ fontSize: "13px", color: "#32B338" }}>
                              -₹ {request.pesticides_subsidy ? request.pesticides_subsidy.toFixed(2) : "00"}
                            </div>
                          </div>
                        )}
                        {Number(request.applied_dsp_coupon_total_amount) != 0 && (
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div style={{ fontSize: "13px", color: "#3B3B3B" }}>DSP Coupon</div>
                            <div style={{ fontSize: "13px", color: "#32B338" }}>
                              -₹{" "}
                              {request.applied_dsp_coupon_total_amount
                                ? request.applied_dsp_coupon_total_amount.toFixed(2)
                                : "00"}
                            </div>
                          </div>
                        )}
                        {Number(request.applied_bhumeet_coupon_total_amount) != 0 && (
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div style={{ fontSize: "13px", color: "#3B3B3B" }}>Bhumeet Coupon</div>
                            <div style={{ fontSize: "13px", color: "#32B338" }}>
                              -₹{" "}
                              {request.applied_bhumeet_coupon_total_amount
                                ? request.applied_bhumeet_coupon_total_amount.toFixed(2)
                                : "00"}
                            </div>
                          </div>
                        )}

                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "10px 0",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        <div>
                          {request.status == STATUS.PAID || request.status == STATUS.COMPLETED
                            ? "Total Amount"
                            : "Estimated Amount"}
                        </div>
                        <div> ₹ {request.total_amount ? request.total_amount.toFixed(2) : "00"}</div>
                      </div>
                    </div>
                  
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row-reverse",
                                padding: "10px 0px 15px",
                                gap: "20px"
                            }}
                        >
                          {showCreateUser && (
                            <Button
                                 text={"Save User"}
                                 className={"btn-large"}
                                 type={"button"}
                                 isDisabled={!request.mobile_number || !request?.name || request?.mobile_number?.length!==10 || !request?.state?.value }
                                 onClick={async()=>{
                                    try{
                                     let {createdUser}=await createUserIfNotExists(request?.name,request?.mobile_number,request?.state?.value);
                                     setDisableIfUserNotExists(false);
                                      if(onuserCreate){
                                        onuserCreate(createdUser)
                                      }
                                    }catch(err){
                                      Popup.alert("ERROR","something went wrong while creating user","ERROR");
                                    }
                                 }}
                             />
                          )}
                            <Button
                                text={"Create"}
                                className={"btn-large"}
                                type={"Save"}
                                onClick={onSubmit}
                                isDisabled={!mapLocation || !request.location_id?.value || !request.crop?.value  || !request.pesticides?.value || loading}
                            />
                            <Button
                                text={"Cancel"}
                                type={"button"}
                                onClick={onClose}
                                isBtnNotActive={true}
                                className={"btn-large "}
                            />
                        </div>
                    </div>
                    </>
                )}
            </Form>
        </div>
    </Modal>
}
export default CreateRequest